import CustomSelect from './base/CustomSelect.jsx'
import { fetchTags } from '../../redux/actions/tags.js'

const AccountTagSelect = (props) => {
  const allProps = { ...props, fetchOptionsAction: () => fetchTags('ACCOUNT_TAGS'), selector: (state) => state['kpi']['ACCOUNT_TAGS'] }
  return (
    <CustomSelect { ...allProps } />
  )
}

export default AccountTagSelect